import { render, staticRenderFns } from "./PostCode.vue?vue&type=template&id=5d7a4613"
import script from "./PostCode.vue?vue&type=script&lang=js"
export * from "./PostCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports